import { modalTypes } from "constants/types";
import localhost, { downloadWithIFrame } from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { hideModal } from "slices/app/actions/modals";
import { addToJobQueue, clearJobQueue } from "slices/app/appSlice";
import { setAuthentication } from "slices/systemAdmin/systemAdminSlice";

export const fetchAuthentication = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/authentication")
    .then(async (response) => {
      const { data } = response;
      dispatch(setAuthentication(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const updateAuthToUsernamePassword = (password) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  const formData = new FormData();
  formData.append("password", password);

  await localhost
    .post("/docs/authentication/usernamePassword", formData)
    .then(async () => {
      dispatch(hideModal(modalTypes.ENABLE_USERNAME_PASSWORD));
      window.location.href = "/login.jsp";
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const updateAuthToSSO = (id, url, cert) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));
  await localhost
    .post("/docs/authentication/sso", {
      id,
      url,
      cert,
    })
    .then(async () => {
      dispatch(hideModal(modalTypes.ENABLE_SSO));
      window.location.href = "/systemAdmin";
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const passwordExpiry = (days) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));
  await localhost
    .post("/docs/authentication/passwordExpiry", null, {
      params: { passwordExpiry: days },
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setAuthentication(data));
      dispatch(hideModal(modalTypes.ENABLE_USERNAME_PASSWORD));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const downloadLogs = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/systemAdmin/downloadLogs")
    .then(({ data }) => {
      const url = `/docs/systemAdmin/downloadLogs?uniqueFolderName=${data}`;
      downloadWithIFrame(url);
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};
